import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import BoxLoader from "../../commons/BoxLoader/BoxLoader";
import SendCheckInModal from "./SendCheckInModal";
import { getAllFinacManagerAction, resetSession } from "../../../redux/auth";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import useDebounce from "../../../customHooks/useDebounce";
import {
  addCheckInScheduleAction,
  getCheckInScheduleListAction,
  getManagersAvailableCheckInScheduleSlotsDetailsAction,
  getSingleCheckInScheduleDetailsAction,
  resetCheckInScheduleList,
  resetManagersAvailableCheckInScheduleSlots,
  resetMySpaceError,
  resetMySpaceMessage,
  resetMySpaceSuccess,
  resetSingleCheckInScheduleDetails,
  updateCheckInScheduleAction,
} from "../../../redux/mySpace";
import {
  GetCheckInScheduleListPayloadType,
  GetManagersCheckInScheduleSlotsPayloadType,
  GetSingleCheckInScheduleDetailsPayloadType,
  UpdateCheckInSchedulePayloadType,
} from "../../../commonTypes/mySpaceType";
import { ErrorSuccessModal } from "../../commons";
import toast, { Toaster } from "react-hot-toast";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import { emitNotification, reverseDate } from "../../../utils/commonFunctions";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import {
  GetCheckInDetailDataType,
  ManagersAvailableCheckInScheduleSlotsListType,
} from "../../../redux/mySpace/mySpaceTypes";
import { MyCheckInsIcon, ViewAllIcon } from "../../../assets/images";
type DropDown = { label: string; value: null | number };

type AppProps = {
  token: null | string;
  history: any;
  fetching: boolean;
  singleCheckInScheduleFetching: boolean;
  isEdit?: boolean;
  showCheckInRequestModal?: boolean;
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) => void;
  setShowCheckInRequestModal?: (data: boolean) => void;
  dispatchGetCheckInScheduleList: (
    data: GetCheckInScheduleListPayloadType
  ) => void;
  dispatchAddCheckInScheduleAction: (
    data: UpdateCheckInSchedulePayloadType
  ) => void;
  totalManagerCount: string | number;
  message: string | null;
  error: string | null;
  type?: string;
  success: number | null;
  statusCode: number | null;
  checkInScheduleTotalCount: number;
  finacManagerList: any;
  checkInScheduleList: GetCheckInDetailDataType[] | [];
  checkInId?: string;
  loginData: LoginResponseType;
  singleCheckInScheduleDetails: GetCheckInDetailDataType;
  dispatchResetMySpaceSuccess: () => void;
  dispatchResetMySpaceMessage: () => void;
  dispatchResetMySpaceError: () => void;
  dispatchResetSession: () => void;
  dispatchResetCheckInScheduleList: () => void;
  dispatchGetSingleCheckInScheduleDetailsAction: (
    data: GetSingleCheckInScheduleDetailsPayloadType
  ) => void;
  dispatchUpdateCheckInScheduleAction: (
    data: UpdateCheckInSchedulePayloadType
  ) => void;
  dispatchResetSingleCheckInScheduleDetails: () => void;
  dispatchGetManagersAvailableCheckInScheduleSlotsDetailsAction: (
    data: GetManagersCheckInScheduleSlotsPayloadType
  ) => void;
  dispatchResetManagersAvailableCheckInScheduleSlots: () => void;
  managersAvailableCheckInScheduleSlots:
    | ManagersAvailableCheckInScheduleSlotsListType[]
    | [];
};

const CheckInModule = ({
  token,
  history,
  fetching,
  dispatchGetAllFinacManagerAction,
  totalManagerCount,
  finacManagerList,
  dispatchAddCheckInScheduleAction,
  message,
  success,
  statusCode,
  dispatchResetMySpaceSuccess,
  dispatchResetMySpaceMessage,
  dispatchResetMySpaceError,
  dispatchResetSession,
  dispatchGetCheckInScheduleList,
  dispatchResetCheckInScheduleList,
  error,
  loginData,
  checkInScheduleList,
  checkInScheduleTotalCount,
  showCheckInRequestModal,
  type,
  checkInId,
  isEdit,
  singleCheckInScheduleFetching,
  singleCheckInScheduleDetails,
  setShowCheckInRequestModal,
  dispatchGetSingleCheckInScheduleDetailsAction,
  dispatchResetSingleCheckInScheduleDetails,
  dispatchUpdateCheckInScheduleAction,
  dispatchGetManagersAvailableCheckInScheduleSlotsDetailsAction,
  dispatchResetManagersAvailableCheckInScheduleSlots,
  managersAvailableCheckInScheduleSlots,
}: AppProps) => {
  const [showSendCheckInRequestModal, setShowSendCheckInRequestModal] =
    useState(false);
  const [finalManagerList, setFinalManagerList] = useState<any>([]);
  const [managerText, setManagerText] = useState<string>("");
  const [managerLimit, setManagerLimit] = useState<number>(20);
  const [managerOffset, setManagerOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [offset, setOffset] = useState<number>(0);
  const [selectedManager, setSelectedManager] = useState<DropDown>({
    value: null,
    label: "Select..",
  });
  const [scheduleTimeAndTate, setScheduleTimeAndTate] = useState<any>("");

  const isEmptyObject = () => {
    return (
      Object.keys(singleCheckInScheduleDetails).length === 0 &&
      singleCheckInScheduleDetails.constructor === Object
    );
  };

  // User Management //
  const [
    isAddCheckInsScheduleButtonPresent,
    setIsAddCheckInsScheduleButtonPresent,
  ] = useMenuCheck("");
  const [isCheckinListPresent, setIsCheckInListPresent] =
    useMenuCheck("Check-Ins");

  // User Management //

  useEffect(() => {
    setIsAddCheckInsScheduleButtonPresent(
      "Add Check-In Schedule Date and Time",
      "menu"
    );
    setIsCheckInListPresent("Check-In Schedule List", "menu");
    dispatchResetMySpaceSuccess();
    dispatchResetMySpaceMessage();
    dispatchResetMySpaceError();
    dispatchResetCheckInScheduleList();
    dispatchResetSingleCheckInScheduleDetails();
    dispatchResetManagersAvailableCheckInScheduleSlots();
    if (token && isCheckinListPresent) {
      const finalData = {
        token,
        userId: loginData?.user_id ? loginData?.user_id : null,
        offset,
        limit,
        role: "user",
      };
      dispatchGetCheckInScheduleList(finalData);
    }
    isEmptyObject() && setScheduleTimeAndTate("");
  }, [isCheckinListPresent]);

  //finacManager
  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: managerOffset,
        limit: managerLimit,
        user_type: "stco_users",
        status: 1,
        search_term: managerText,
      };
      if (managerOffset <= +totalManagerCount) {
        dispatchGetAllFinacManagerAction(finalUserData);
      }
    }
  }, [managerOffset]);

  useEffect(() => {
    dispatchResetManagersAvailableCheckInScheduleSlots();
    if (token && scheduleTimeAndTate && selectedManager) {
      const finalData = {
        token,
        date: scheduleTimeAndTate
          ? reverseDate(scheduleTimeAndTate?.split(",")[0])
          : "",
        userId: selectedManager?.value ? selectedManager?.value : null,
      };
      dispatchGetManagersAvailableCheckInScheduleSlotsDetailsAction(finalData);
    }
  }, [selectedManager, scheduleTimeAndTate]);

  useEffect(() => {
    const data = finacManagerList?.filter(
      (e: any) => e?.user_id !== loginData?.user_id
    );
    const finalManagerData = data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${
          user?.last_name ? user?.last_name : ""
        }%${user?.job_title ? user?.job_title : ""} ${
          user?.department ? "|" : ""
        } ${user?.department !== null ? user?.department : ""}`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (managerOffset > 0) {
      setFinalManagerList([...finalManagerList, ...finalManagerData]);
    } else {
      setFinalManagerList(finalManagerData);
    }
  }, [finacManagerList]);

  useEffect(() => {
    if (showCheckInRequestModal) {
      setShowSendCheckInRequestModal(!showSendCheckInRequestModal);
    }
  }, [showCheckInRequestModal]);

  useEffect(() => {
    dispatchResetSingleCheckInScheduleDetails();
    if (checkInId && token) {
      const finalData = {
        token,
        checkInId: checkInId,
      };
      dispatchGetSingleCheckInScheduleDetailsAction(finalData);
    }
  }, [checkInId]);

  const fetchNewManagerData = (search: string) => {
    const finalData = {
      token,
      offset: managerOffset,
      limit: managerLimit,
      user_type: "stco_users",
      status: 1,
      search_term: managerText,
    };
    dispatchGetAllFinacManagerAction(finalData);
  };

  useDebounce(
    () => {
      if (managerText) {
        fetchNewManagerData(managerText);
      } else {
        const finalData = {
          token,
          offset: managerOffset,
          limit: managerLimit,
          user_type: "stco_users",
          status: 1,
          search_term: managerText,
        };
        dispatchGetAllFinacManagerAction(finalData);
      }
    },
    500,
    [managerText]
  );

  useEffect(() => {
    if (!showSendCheckInRequestModal) {
      setShowCheckInRequestModal?.(false);
    }
  }, [showSendCheckInRequestModal]);

  const addCheckInScheduleData = (data: any) => {
    if (token) {
      const finalData = {
        token,
        ...data,
      };
      dispatchAddCheckInScheduleAction(finalData);
    }
  };

  const updateCheckInScheduleData = (data: any) => {
    if (token) {
      const finalData = {
        token,
        ...data,
      };
      dispatchUpdateCheckInScheduleAction(finalData);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetMySpaceError();
            }}
          />
        );
      }
    } else {
      if (
        (success &&
          message?.includes("Check-in details has been added successfully!")) ||
        message?.includes("Check-in details has been updated successfully!")
      ) {
        toast.success(
          `${
            message.includes("Check-in details has been updated successfully!")
              ? "Check-in details has been updated successfully!"
              : "Check-in details has been added successfully!"
          }`,
          {
            duration: 3000,
          }
        );
    emitNotification( "notificationEvent",
      {receiver_id:String(selectedManager?.value) },)
        dispatchResetMySpaceSuccess();
        dispatchResetMySpaceMessage();
        dispatchResetCheckInScheduleList();
        if (token) {
          const finalData = {
            token,
            userId: loginData?.user_id ? loginData?.user_id : null,
            offset,
            limit,
            role: "user",
          };
          isCheckinListPresent && dispatchGetCheckInScheduleList(finalData);
        }
      }
    }

    return false;
  };

  return (
    <>
      {!type?.length && (
        <div
          className="boxs w-100 pt-3 pb-3 pl-2 pr-2"
          style={{ height: "125px" }}
        >
          {fetching ? (
            <BoxLoader style={{ height: "100%" }} />
          ) : (
            <>
              <div style={{ display: "flex", gap: "6px", marginTop: "10px" }}>
                <img
                  src={MyCheckInsIcon}
                  alt="Checkin list Icon"
                  style={{ width: "67px" }}
                />
                <div>
                  <span className="boxs-container-heading">My Check-Ins</span>
                  <div className="">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ fontSize: "35px", fontWeight: 500 }}>
                        {checkInScheduleTotalCount}
                      </div>

                      {isAddCheckInsScheduleButtonPresent && (
                        <button
                          className="btn btn-outline btn-sm ml-2"
                          onClick={() => {
                            setShowSendCheckInRequestModal(
                              !showSendCheckInRequestModal
                            );
                            dispatchResetSingleCheckInScheduleDetails();
                          }}
                        >
                          Schedule
                        </button>
                      )}

                      {isCheckinListPresent && (
                        <div
                          className="ml-3"
                          style={{ color: "#dd4433", cursor: "pointer" }}
                          onClick={() => {
                            history.push({
                              pathname: `/my-space/check-in-list`,
                              state: { activeTab: "myCheckInList" },
                            });
                          }}
                        >
                          <img src={ViewAllIcon} alt="view all Icon" />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {showSendCheckInRequestModal && (
        <SendCheckInModal
          setShowSendCheckInRequestModal={setShowSendCheckInRequestModal}
          finalManagerList={finalManagerList}
          setManagerOffset={setManagerOffset}
          managerLimit={managerLimit}
          addCheckInScheduleData={addCheckInScheduleData}
          updateCheckInScheduleData={updateCheckInScheduleData}
          setManagerText={setManagerText}
          isEdit={isEdit}
          singleCheckInScheduleDetails={singleCheckInScheduleDetails}
          dispatchResetSingleDetails={dispatchResetSingleCheckInScheduleDetails}
          selectedManager={selectedManager}
          setSelectedManager={setSelectedManager}
          scheduleTimeAndTate={scheduleTimeAndTate}
          setScheduleTimeAndTate={setScheduleTimeAndTate}
          managersAvailableCheckInScheduleSlots={
            managersAvailableCheckInScheduleSlots
          }
        />
      )}
      {handleErrorModal()}
      <Toaster />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.mySpace.checkInScheduleFetching,
  finacManagerList: state.auth.finacManagerList,
  totalManagerCount: state.auth.totalManagerCount,
  message: state.mySpace.message,
  success: state.mySpace.success,
  statusCode: state.mySpace.statusCode,
  error: state.mySpace.error,
  loginData: state.auth.loginData,
  checkInScheduleList: state.mySpace.checkInScheduleList,
  checkInScheduleTotalCount: state.mySpace.checkInScheduleTotalCount,
  singleCheckInScheduleDetails: state.mySpace.singleCheckInScheduleDetails,
  managersAvailableCheckInScheduleSlots:
    state.mySpace.managersAvailableCheckInScheduleSlots,
  singleCheckInScheduleFetching: state.mySpace.singleCheckInScheduleFetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacManagerAction(data)),
  dispatchAddCheckInScheduleAction: (data: UpdateCheckInSchedulePayloadType) =>
    dispatch(addCheckInScheduleAction(data)),
  dispatchUpdateCheckInScheduleAction: (
    data: UpdateCheckInSchedulePayloadType
  ) => dispatch(updateCheckInScheduleAction(data)),
  dispatchGetCheckInScheduleList: (data: GetCheckInScheduleListPayloadType) =>
    dispatch(getCheckInScheduleListAction(data)),
  dispatchResetMySpaceSuccess: () => dispatch(resetMySpaceSuccess()),
  dispatchResetMySpaceMessage: () => dispatch(resetMySpaceMessage()),
  dispatchResetMySpaceError: () => dispatch(resetMySpaceError()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetCheckInScheduleList: () => dispatch(resetCheckInScheduleList()),
  dispatchGetSingleCheckInScheduleDetailsAction: (
    data: GetSingleCheckInScheduleDetailsPayloadType
  ) => dispatch(getSingleCheckInScheduleDetailsAction(data)),
  dispatchGetManagersAvailableCheckInScheduleSlotsDetailsAction: (
    data: GetManagersCheckInScheduleSlotsPayloadType
  ) => dispatch(getManagersAvailableCheckInScheduleSlotsDetailsAction(data)),
  dispatchResetSingleCheckInScheduleDetails: () =>
    dispatch(resetSingleCheckInScheduleDetails()),
  dispatchResetManagersAvailableCheckInScheduleSlots: () =>
    dispatch(resetManagersAvailableCheckInScheduleSlots()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckInModule);
